<template>
    <v-app>
        <vacations-core-app-bar v-model="expandOnHover" v-if="get_shared_Path === 'Vacations'" />
        <vacations-core-app-bar-status-overview v-model="expandOnHover" v-if="get_shared_Path === 'Status Overview'" />

        <vacations-core-drawer :expand-on-hover.sync="expandOnHover" />

        <vacations-core-view />

        <vacations-core-footer />
    </v-app>
</template>

<script>
	import { mapGetters } from 'vuex';


    export default {
        name: 'VacationsIndex',

        /* >>> *************************************************************** / /* Components */
        components: {

            VacationsCoreAppBar: () => import('./vacations/components/core/AppBar'),
            VacationsCoreAppBarStatusOverview: () => import('./statusoverview/components/core/AppBar'),

            VacationsCoreDrawer: () => import('@/components/core/Drawer'), // global
            VacationsCoreView: () => import('@/components/core/View'), // global
            VacationsCoreFooter: () => import('@/components/core/Footer') // global

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            expandOnHover: true

        }), // eo data{}
        /* <<< ****************************************************************/


		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_shared_Path',
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/

    };
</script>
